function getTypeEvent() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
}

export default {
  getType() {
    return getTypeEvent();
  },
  //滚动距离动画
  disAnimation: function (_this) {

    let scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    let allBody =
      _this.$parent.$refs.footerContain.$el.offsetHeight +
      _this.$refs.content.offsetHeight +
      115;
    let scrollHeight =
      window.pageYHeight ||
      document.documentElement.scrollHeight ||
      document.body.scrollHeight;
      _this.shu = (allBody / scrollHeight) * scrollTop;
  },
}